import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Badge from '../Badge';

const GDA_TYPE_ID = 10;

const getStyles = (showLabels, index) => {
  if (index === 0) return { marginLeft: '0' };
  if (showLabels) return { marginLeft: '1em' };

  return {
    marginLeft: '5px',
  };
};

const buildLink = ({
  locationSlug,
  selectedDate,
  selectedSeats,
  selectedTime,
  slug,
}) => `/cities/${locationSlug}/list/${slug}?date=${selectedDate}&seats=${selectedSeats}&time=${selectedTime}`;

const BadgeCollection = ({
  badges,
  locationSlug,
  onClick,
  selectedDate,
  selectedSeats,
  selectedTime,
  showLabels,
  size,
}) => (
  <>
    {badges.map((badge, index) => (
      <Badge
        id={badge.id}
        url={badge.image}
        title={badge.short_name}
        label={showLabels ? badge.short_name : null}
        onClick={onClick}
        name={badge.file_name}
        key={badge.id}
        isGda={badge.type_id === GDA_TYPE_ID}
        style={getStyles(showLabels, index)}
        link={buildLink({
          locationSlug,
          selectedDate,
          selectedSeats,
          selectedTime,
          slug: badge.collection_slug,
        })}
        size={size}
      />
    ))}
  </>
);

BadgeCollection.propTypes = {
  badges: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    file_name: PropTypes.string,
    image: PropTypes.string,
    short_name: PropTypes.string,
    type_id: PropTypes.number,
  })),
  locationSlug: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  selectedDate: PropTypes.string.isRequired,
  selectedSeats: PropTypes.number.isRequired,
  selectedTime: PropTypes.number.isRequired,
  showLabels: PropTypes.bool,
  size: PropTypes.string,
};

BadgeCollection.defaultProps = {
  badges: [],
  onClick: () => {},
  showLabels: true,
  size: '16',
};

const mapStateToProps = ({ resyCore, resyLocations }) => ({
  locationSlug: resyLocations.selected?.url_slug,
  selectedDate: resyCore.selectedCoreISODate,
  selectedSeats: resyCore.selectedCoreSeats,
  selectedTime: resyCore.selectedCoreTime,
});

BadgeCollection.displayName = 'BadgeCollection';
export default connect(mapStateToProps)(BadgeCollection);
export { BadgeCollection as ComponentUnderTest };
